<template>
  <form @submit.prevent="handleSubmit" enctype="multipart/form-data" class="registro-form container py-4">
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <label>Nombre del padre</label>
        <input v-model="form.padre.nombre_completo" type="text" class="form-control" placeholder="Nombres y Apellidos" />
      </div>
      <div class="col-md-6 mb-3">
        <label>Nombre de la madre</label>
        <input v-model="form.madre.nombre_completo" type="text" class="form-control" placeholder="Nombres y Apellidos" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <label>Teléfono (Sin espacios)</label>
        <input v-model="form.contacto.telefono" type="tel" class="form-control" required />
      </div>
      <div class="col-md-6 mb-3">
        <label>Correo electrónico</label>
        <input v-model="form.contacto.correo" type="email" class="form-control" required />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <label>Departamento</label>
        <input v-model="form.contacto.departamento" type="text" class="form-control" required />
      </div>
      <div class="col-md-6 mb-3">
        <label>Ciudad</label>
        <input v-model="form.contacto.ciudad" type="text" class="form-control" required />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <label>El formato del dibujo del Doctor Muelitas lo recibió en:</label>
        <select v-model="form.origen_formato.formato_dibujo_recibido_en" class="form-select" required>
          <option disabled value="">Selecciona una opción</option>
          <option value="institucion_educativa">Institución Educativa</option>
          <option value="festival_buen_comienzo">Festival Buen Comienzo</option>
        </select>
        <small class="text-muted">Si seleccionas “Institución Educativa”, debes especificar el nombre.</small>
      </div>

      <div
        class="col-md-6 mb-3"
        v-if="form.origen_formato.formato_dibujo_recibido_en === 'institucion_educativa'"
      >
        <label>Nombre de la institución (obligatorio)</label>
        <input
          v-model="form.origen_formato.nombre_institucion"
          type="text"
          class="form-control"
          placeholder="institución"
          required
        />
      </div>
    </div>

    <div
      v-for="(hijo, index) in hijos"
      :key="index"
      class="border rounded p-3 mb-3 position-relative hijo-card"
    >
      <h5 class="fw-bold">Hijo {{ index + 1 }}</h5>

      <button
        v-if="hijos.length > 1"
        type="button"
        class="btn-close position-absolute top-0 end-0 m-3"
        aria-label="Eliminar hijo"
        @click="removeHijo(index)"
      ></button>

      <div class="mb-2">
        <label>Nombre Completo</label>
        <input v-model="hijo.nombre" type="text" class="form-control" placeholder="Nombres y Apellidos" required />
      </div>
      <div class="mb-2">
        <label>Fecha de nacimiento</label>
        <input v-model="hijo.fecha_nacimiento" type="date" class="form-control" required />
      </div>
      <div class="mb-2">
        <label>Foto (dibujo)</label>
        <input
          type="file"
          accept="image/*"
          @change="onImageSelected($event, index)"
          class="form-control"
          :ref="el => fileInputs[index] = el"
        />
      </div>

      <div v-if="previews[index]" class="mt-2 position-relative d-inline-block">
        <img :src="previews[index]" class="img-thumbnail" style="max-width: 200px" />
        <button
          type="button"
          class="position-absolute top-0 end-0 m-1 bg-danger text-white rounded-circle d-flex align-items-center justify-content-center"
          style="width: 28px; height: 28px; font-weight: bold; border: none;"
          @click="removePreview(index)"
          aria-label="Eliminar imagen"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <button type="button" class="btn btn-outline-secondary mb-4" @click="addHijo">+ Agregar otro hijo</button>

    <div class="form-check mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="autorizaUsoDibujo"
        v-model="form.autoriza_uso_dibujo"
        :true-value="true"
        :false-value="false"
        required
      />
      <label class="form-check-label" for="autorizaUsoDibujo">
        Autorizo el uso del dibujo de mi hijo(a) en el calendario Colgate Palmolive 2026 en caso de ser seleccionado.
      </label>
    </div>

    <div class="form-check mb-4">
      <input
        class="form-check-input"
        type="checkbox"
        id="habeasData"
        v-model="form.habeas_data"
        :true-value="true"
        :false-value="false"
        required
      />
      <label class="form-check-label" for="habeasData">
        Autorizo la recolección, almacenamiento, uso, tratamiento, y transmisión internacional o a terceros de mis datos personales por parte de <strong>COLGATE PALMOLIVE COMPAÑÍA</strong> con <strong>NIT 890.300.546-6</strong>, con el fin de recibir información sobre sus productos, campañas publicitarias y promociones, hacer parte de sus actividades para profesionales de la salud y recibir información comercial especializada de la misma. Esto de acuerdo a lo establecido en la Ley 1581 de 2012 y el decreto 377 de 2013, y conforme a la política de datos personales disponible en <a href="https://www.colgatepalmolive.com.co/legal-privacy-policy" target="_blank">https://www.colgatepalmolive.com.co/legal-privacy-policy</a>.
      </label>
    </div>

    <div class="d-grid">
      <button type="submit" class="btn btn-enviar">Enviar registro</button>
    </div>
  </form>
</template>

<script setup>
import { ref } from 'vue'
import Swal from 'sweetalert2'
import api from '../services/api'

const letrasEspacios = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/
const soloNumeros = /^[0-9]+$/
const correoValido = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/

const form = ref({
  padre: { nombre_completo: '' },
  madre: { nombre_completo: '' },
  contacto: {
    telefono: '',
    correo: '',
    departamento: '',
    ciudad: ''
  },
  origen_formato: {
    formato_dibujo_recibido_en: '',
    nombre_institucion: ''
  },
  autoriza_uso_dibujo: false,
  habeas_data: false
})

const hijos = ref([{ nombre: '', fecha_nacimiento: '', foto: null }])
const previews = ref([])
const fileInputs = ref([])

const addHijo = () => {
  hijos.value.push({ nombre: '', fecha_nacimiento: '', foto: null })
}

const removeHijo = (index) => {
  hijos.value.splice(index, 1)
  previews.value.splice(index, 1)
  fileInputs.value.splice(index, 1)
}

const onImageSelected = (event, index) => {
  const file = event.target.files[0]
  const tiposPermitidos = ['image/jpeg', 'image/png', 'image/jpg']

  if (file && tiposPermitidos.includes(file.type)) {
    hijos.value[index].foto = file
    previews.value[index] = URL.createObjectURL(file)
  } else {
    Swal.fire('Error', 'Formato de imagen no válido. Solo se permite PNG, JPEG o JPG.', 'error')
    fileInputs.value[index].value = ''
    hijos.value[index].foto = null
    previews.value[index] = null
  }
}

const removePreview = (index) => {
  hijos.value[index].foto = null
  previews.value[index] = null
  const input = fileInputs.value[index]
  if (input) input.value = ''
}

const handleSubmit = async () => {
  const { padre, madre, contacto } = form.value

  if (padre.nombre_completo && !letrasEspacios.test(padre.nombre_completo)) {
    return Swal.fire('Error', 'El nombre del padre solo puede contener letras y espacios.', 'error')
  }
  if (madre.nombre_completo && !letrasEspacios.test(madre.nombre_completo)) {
    return Swal.fire('Error', 'El nombre de la madre solo puede contener letras y espacios.', 'error')
  }
  if (!soloNumeros.test(contacto.telefono)) {
    return Swal.fire('Error', 'El teléfono solo debe contener números (sin espacios).', 'error')
  }
  if (!correoValido.test(contacto.correo)) {
    return Swal.fire('Error', 'El correo electrónico no es válido.', 'error')
  }
  if (!letrasEspacios.test(contacto.departamento)) {
    return Swal.fire('Error', 'El departamento solo puede contener letras y espacios.', 'error')
  }
  if (!letrasEspacios.test(contacto.ciudad)) {
    return Swal.fire('Error', 'La ciudad solo puede contener letras y espacios.', 'error')
  }

  for (let i = 0; i < hijos.value.length; i++) {
    const hijo = hijos.value[i]
    if (!letrasEspacios.test(hijo.nombre)) {
      return Swal.fire('Error', `El nombre del hijo ${i + 1} solo puede contener letras y espacios.`, 'error')
    }
    if (!hijo.fecha_nacimiento) {
      return Swal.fire('Error', `La fecha de nacimiento del hijo ${i + 1} es obligatoria.`, 'error')
    }
    if (!hijo.foto) {
      return Swal.fire('Error', `La foto del hijo ${i + 1} es obligatoria.`, 'error')
    }
  }

  if (!form.value.origen_formato.formato_dibujo_recibido_en) {
    return Swal.fire('Error', 'Debes seleccionar dónde recibió el formato.', 'error')
  }
  if (form.value.origen_formato.formato_dibujo_recibido_en === 'institucion_educativa') {
    const ie = String(form.value.origen_formato.nombre_institucion || '').trim()
    if (!ie) {
      return Swal.fire('Error', 'Debes especificar el nombre de la institución educativa.', 'error')
    }
    form.value.origen_formato.nombre_institucion = ie
  } else {
    form.value.origen_formato.nombre_institucion = ''
  }

  if (form.value.autoriza_uso_dibujo !== true) {
    return Swal.fire('Error', 'Debes autorizar el uso del dibujo para continuar.', 'error')
  }
  if (form.value.habeas_data !== true) {
    return Swal.fire('Error', 'Debes aceptar el habeas data para continuar.', 'error')
  }

  try {
    Swal.fire({
      title: 'Enviando...',
      text: 'Por favor espera unos segundos',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    const formData = new FormData()
    formData.append('padre', JSON.stringify(padre))
    formData.append('madre', JSON.stringify(madre))
    formData.append('contacto', JSON.stringify(contacto))
    formData.append(
      'hijos',
      JSON.stringify(
        hijos.value.map(({ nombre, fecha_nacimiento }) => ({
          nombre,
          fecha_nacimiento
        }))
      )
    )

    formData.append(
      'origen_formato',
      JSON.stringify({
        formato_dibujo_recibido_en: form.value.origen_formato.formato_dibujo_recibido_en,
        ...(form.value.origen_formato.formato_dibujo_recibido_en === 'institucion_educativa' &&
          { nombre_institucion: form.value.origen_formato.nombre_institucion })
      })
    )
    formData.append('autoriza_uso_dibujo', JSON.stringify(true))
    formData.append('habeas_data', JSON.stringify(true))

    hijos.value.forEach((hijo, i) => {
      if (hijo.foto) {
        formData.append(`foto${i}`, hijo.foto)
      }
    })

    await api.post('/registro', formData)
    Swal.fire('Éxito', 'Registro enviado correctamente', 'success')

    form.value = {
      padre: { nombre_completo: '' },
      madre: { nombre_completo: '' },
      contacto: {
        telefono: '',
        correo: '',
        departamento: '',
        ciudad: ''
      },
      origen_formato: {
        formato_dibujo_recibido_en: '',
        nombre_institucion: ''
      },
      autoriza_uso_dibujo: false,
      habeas_data: false
    }
    hijos.value = [{ nombre: '', fecha_nacimiento: '', foto: null }]
    previews.value = []
    fileInputs.value = []
  } catch (error) {
    const msg = error.response?.data?.error || 'Ocurrió un error al enviar el formulario'
    Swal.fire('Error', msg, 'error')
  }
}
</script>

<style scoped>
.registro-form {
  background-color: #fff;
  border-radius: 12px;
  max-width: 900px;
  margin: 0 auto;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);
}

label {
  font-weight: 500;
  margin-bottom: 6px;
}

input[type="text"],
input[type="email"],
input[type="tel"],
input[type="date"],
input[type="file"] {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  transition: border-color 0.3s;
}

input:focus {
  border-color: #e63946;
  outline: none;
  box-shadow: 0 0 0 2px rgba(230, 57, 70, 0.2);
}

.btn-enviar {
  background-color: #EE122A;
  border: none;
  color: #ffffff;
  font-weight: 600;
  padding: 12px;
  border-radius: 8px;
  font-size: 1.1rem;
  transition: background-color 0.3s, transform 0.2s, color 0.2s;
}

.btn-enviar:hover {
  background-color: #c12736;
  color: #ffffff; 
  transform: scale(1.02);
}

.btn-outline-secondary {
  border-radius: 8px;
  padding: 10px 16px;
  font-weight: 500;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.btn-outline-secondary:hover {
  background-color: #2d6a4f;
  color: #fff;
  border-color: #2d6a4f;
}

.hijo-card {
  background-color: #fafafa;
}

.form-check {
  display: flex;
  align-items: flex-start;
  gap: .6rem;
}

.form-check-input {
  flex: 0 0 auto;
}

.form-check-input {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: .2rem;         
  flex: 0 0 auto;
  accent-color: #12c2ee;     
}

input:not([type="checkbox"]):focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(230, 57, 70, 0.2);
}
.form-check-input:focus {
  border-color: #12c2ee;
  box-shadow: none;
  outline: none;
}

.form-check-label {
  display: block;
  flex: 1 1 0%;
  min-width: 0;             
  max-width: 100%;
  white-space: normal;
  overflow-wrap: break-word; 
  word-break: break-word;    
  line-height: 1.45;
}
.form-check-label a {
  overflow-wrap: anywhere;
  word-break: break-all;     
}

@media (max-width: 768px) {
  input {
    width: 100%;
    font-size: 1.05rem;
  }

  .btn-enviar {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  input {
    width: 100%;
    font-size: 1.05rem;
  }

  .btn-enviar {
    font-size: 1rem;
  }

  .form-check {
    gap: .75rem;
  }

  .form-check-input {
    width: 1.35rem;
    height: 1.35rem;
  }

  .form-check-label {
    font-size: .98rem;
    line-height: 1.5;
  }
}
</style>
